import { Component } from 'react';
import { Navigate } from 'react-router-dom';

import { 
  ThemeProvider, 
  createTheme, 
} from '@mui/material/styles';
import {
  Box,
  Typography,
  FormControl,
  TextField,
  Button,
  Alert,
} from '@mui/material';

import { HttpStatusCode } from 'axios';

import { withTranslation } from 'react-i18next';
import i18n from '../assets/locales';

import Layout from '../layouts/layout.component';

type Props = {};

type State = {
  redirect: string | null,
};

const theme = createTheme({
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: 13,
          fontWeight: 'bold',
          color: 'rgba(224, 224, 224, 0.98)' ,
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          // Standard
          '& .MuiInput-root': {
            color: 'rgba(255, 255, 255, 0.8)',
            // fontFamily: 'Arial',
            fontWeight: 'bold',
            '&:before': {
              borderColor: 'rgba(128, 128, 128, 0.8)',
              borderWidth: '1px',
            },
            '&:after': {
              borderColor: 'rgba(0, 98, 65, 0.8)',
              borderWidth: '2px',
            },
            ':hover:not(.Mui-focused)': {
              '&:before': {
                borderColor: 'rgba(231, 231, 231, 0.8)',
                borderWidth: '1px',
              },
            },
          },
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          '& .MuiAlert-message': {
            color: 'rgba(0, 0, 0, 1)'
          }
        }
      }
    }
  }
});

class ResetPasswordExpired extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.onSignin = this.onSignin.bind(this);

    this.state = {
      redirect: null,
    };
  }

  componentDidMount() {
    // const currentUser = AuthService.getCurrentUser();

    // if (currentUser) {
    //   this.setState({ redirect: '/profile' });
    // };
  }

  componentWillUnmount() {
    window.location.reload();
  }

  onSignin() {
    this.setState({ redirect: '/signin' });
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.redirect} />
    }
    
    return(
      <Layout>
        <div className='container col-md-12'>
          <Box sx={{ height: 10 }} />
          <div className='container-fluid'>
            <Typography variant='h5'><b>Create new password</b></Typography>
          </div>
          <Box sx={{ height: 20 }} />
          <div className='container-fluid'>
            <Typography variant='h6'>Your password has been reset successfully.</Typography>
          </div>
          <Box sx={{ height: 20 }} />
          <div className='container card card-container' style={{background: 'transparent'}}>
            <Button className='btn btn-primary btn-block w-100' onClick={this.onSignin}>
              Sign in
            </Button>
          </div>
        </div>
      </Layout>
    )
  }
}

export default withTranslation()(ResetPasswordExpired)
